import React from 'react';

const Checkbox = React.forwardRef(({ className = '', ...props }, ref) => {
  return (
    <input
      type="checkbox"
      ref={ref}
      className={`w-4 h-4 text-tenant-hover bg-white border-gray-300 rounded focus:ring-tenant-primary focus:ring-2 cursor-pointer transition-colors ${className}`}
      {...props}
    />
  );
});

Checkbox.displayName = 'Checkbox';

export default Checkbox;
